import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material";
import { ExcelService, Combo2Service, ComboService } from "../../../../services/index";
import { SalesOrderService } from "../../../../services/salesOrder.service";
import { FormControl } from "@angular/forms";
import * as _ from "lodash";
import { template } from "lodash";
import { ToasterService } from "angular2-toaster";
import swal from "sweetalert2";

@Component({
  selector: "countCustomer",
  templateUrl: "countCustomer.html",
})
export class countCustomer implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  seasonList = [];
  finyearList = [];
  seasonfinList = [];
  isLoadMask: Promise<any>;
  loadingIndicator: boolean;
  gridOptions: any;
  IsWait: boolean = false;
  Iselected_party: boolean = false;
  party_view: boolean = false;
  IsShow: boolean = true;
  IscancelShow: boolean = false;
  so_id: any;
  exceldata: any;
  attachment: any;
  curDate = new Date();
  ordStyleList = ["FORMAL", "CASUAL", "RR FORMAL", "RR CASUAL", "CLUB"];
  reasonList = ["Fabric Shortage", "Fabric Damage", "Cancel Order"];

  filter = {
    finyear: "",
    fin_id: "",
    party_id: "",
    season_id: "",
    party_name: "",
    est_partyid: 0,
    season: "",
    from_date: "",
    to_date: "",
    ord_style: "",
    newDesignShade: "",
    shade: "",
    groupby: "designColor",
    so_no: "",
    book_no: ""
  };
  tot_data = {
    st_f36: 0,
    st_f38: 0,
    st_f40: 0,
    st_f42: 0,
    st_f44: 0,
    st_f46: 0,
    st_h36: 0,
    st_h38: 0,
    st_h40: 0,
    st_h42: 0,
    st_h44: 0,
    st_h46: 0,
    st_tot: 0,
    bal_f36: 0,
    bal_f38: 0,
    bal_f40: 0,
    bal_f42: 0,
    bal_f44: 0,
    bal_f46: 0,
    bal_h36: 0,
    bal_h38: 0,
    bal_h40: 0,
    bal_h42: 0,
    bal_h44: 0,
    bal_h46: 0,
    bal_tot: 0,
    so_f36: 0,
    so_f38: 0,
    so_f40: 0,
    so_f42: 0,
    so_f44: 0,
    so_f46: 0,
    so_h36: 0,
    so_h38: 0,
    so_h40: 0,
    so_h42: 0,
    so_h44: 0,
    so_h46: 0,
    so_tot: 0,
    est_f36: 0,
    est_f38: 0,
    est_f40: 0,
    est_f42: 0,
    est_f44: 0,
    est_f46: 0,
    est_h36: 0,
    est_h38: 0,
    est_h40: 0,
    est_h42: 0,
    est_h44: 0,
    est_h46: 0,
    est_tot: 0
  }
  columns = [];
  excelColumns = [];
  toggleCol = [];
  newDesignList = [];
  partyList = [];

  pendingOrderStock: any;
  totpartyOrder: any;
  shirtStock = [];
  partyData = [];
  style_name: any;
  variety_name: any;
  tot_stock: any = 0;
  tab_index: boolean = false;
  est_stock: any
  stockOrder: any;
  balance_qty: any;
  totalOrderPend: any;
  cancel_data = [];

  constructor(
    private salesOrderServ: SalesOrderService,
    private spin: MatProgressSpinnerModule,
    public toasterService: ToasterService,
    private excelService: ExcelService,
    private combo: Combo2Service,
    public datePipe: DatePipe,
    public comboservice: ComboService

  ) {
    let from_date =
      this.curDate.getFullYear() +
      "-" +
      this.curDate.getMonth() +
      "-" +
      this.curDate.getDate(),
      to_date =
        this.curDate.getFullYear() +
        "-" +
        (this.curDate.getMonth() + 1) +
        "-" +
        this.curDate.getDate();

    // this.filter.from_date = this.datePipe.transform(from_date, "yyyy-MM-dd");
    // this.filter.to_date = this.datePipe.transform(to_date, "yyyy-MM-dd");
    this.loadingIndicator = true;
  }

  ngOnInit(): void {
    // this.finyearCombo();
    this.getPartyList();
    this.getSeasonList();
    this.getNewDesignList();
    this.getColumns();
    this.columns = [];

    
    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };

    this.toggleCol = Object.assign({}, this.columns);
  }

  getColumns() {
    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);

  }

  dcAuto() {


    this.salesOrderServ.GetCountdcAuto({}).then((res: any) => {
    });

  }

  // Oncheckqty() {

  //   for (let i = 0; i < this.shirtStock.length; i++) {
  //     let temp = this.shirtStock[i]
  //     if (temp.bf36 < 0 || temp.bf38 < 0 || temp.bf40 < 0 || temp.bf42 < 0 || temp.bf44 < 0 || temp.bf46 < 0 ||
  //       temp.bh36 < 0 || temp.bh38 < 0 || temp.bh40 < 0 || temp.bh42 < 0 || temp.bh44 < 0 || temp.bh46 < 0) {
  //       swal('ERROR', ',<h2>Qty Greater Than Stock</h2>', 'error');
  //       break
  //     }
  //     else {
  //       this.SaveCustomerCount()
  //     }
  //   }
  // }
  SaveCustomerCount() {

    let params: any = Object.assign({}, this.filter);
    params["shirt_data"] = JSON.stringify(this.shirtStock);
    params["ord_data"] = JSON.stringify(this.pendingOrderStock);
    params["style"] = this.style_name;
    params["variety"] = this.variety_name;

    let that = this;
    swal({
      title: "Are you sure to save this Details?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {

      that.salesOrderServ
        .SaveCustomerCount(params)
        .then(function (res: any) {

          if (res.success) {
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });

            that.resetTotal();
          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });
  }
  resetTotal() {
    this.IsWait = false;
    this.shirtStock = [];
    this.pendingOrderStock = [];
    this.Iselected_party = false;
    this.totpartyOrder = [];
    this.tot_data.so_f36 = 0;
    this.tot_data.so_f38 = 0;
    this.tot_data.so_f40 = 0;
    this.tot_data.so_f42 = 0;
    this.tot_data.so_f44 = 0;
    this.tot_data.so_f46 = 0;
    this.tot_data.so_h36 = 0;
    this.tot_data.so_h38 = 0;
    this.tot_data.so_h40 = 0;
    this.tot_data.so_h42 = 0;
    this.tot_data.so_h44 = 0;
    this.tot_data.so_h46 = 0;
    this.tot_data.so_tot = 0;


    this.tot_data.st_f36 = 0;
    this.tot_data.st_f38 = 0;
    this.tot_data.st_f40 = 0;
    this.tot_data.st_f42 = 0;
    this.tot_data.st_f44 = 0;
    this.tot_data.st_f46 = 0;
    this.tot_data.st_h36 = 0;
    this.tot_data.st_h38 = 0;
    this.tot_data.st_h40 = 0;
    this.tot_data.st_h42 = 0;
    this.tot_data.st_h44 = 0;
    this.tot_data.st_h46 = 0;
    this.tot_data.st_tot = 0;



    this.tot_data.bal_f36 = 0;
    this.tot_data.bal_f38 = 0;
    this.tot_data.bal_f40 = 0;
    this.tot_data.bal_f42 = 0;
    this.tot_data.bal_f44 = 0;
    this.tot_data.bal_f46 = 0;
    this.tot_data.bal_h36 = 0;
    this.tot_data.bal_h38 = 0;
    this.tot_data.bal_h40 = 0;
    this.tot_data.bal_h42 = 0;
    this.tot_data.bal_h44 = 0;
    this.tot_data.bal_h46 = 0;
    this.tot_data.bal_tot = 0;


    this.tot_data.est_f36 = 0;
    this.tot_data.est_f38 = 0;
    this.tot_data.est_f40 = 0;
    this.tot_data.est_f42 = 0;
    this.tot_data.est_f44 = 0;
    this.tot_data.est_f46 = 0;
    this.tot_data.est_h36 = 0;
    this.tot_data.est_h38 = 0;
    this.tot_data.est_h40 = 0;
    this.tot_data.est_h42 = 0;
    this.tot_data.est_h44 = 0;
    this.tot_data.est_h46 = 0;
    this.tot_data.est_tot = 0;


    this.tot_stock = 0;
    this.est_stock = 0;
    this.balance_qty = 0;
  }
  getNewDesignList() {
    this.salesOrderServ.getNewDesignList({}).then((res: any) => {
      this.newDesignList = res;
    });
  }
  getPartyList() {
    let params = {
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getSalesParty(params).then((res: any) => {
      this.partyList = res;
    });
  }
  onSelectParty(party) {
    this.partyList.forEach((element) => {
      if (party == element.name) {
        this.filter.party_id = element.genLedid;
      }
    });

  }
  getSeasonList() {
    let params = {
      date: new Date().getFullYear(),
      page: 1,
      start: 0,
      limit: 100,
      page_type: 'counter_screen'
    };
    this.comboservice.getBrandNewSeason(params).then((res: any) => {
      this.seasonList = res;
    });
  }
  onSelectSeason(season) {
    this.seasonList.forEach((element) => {
      if (season == element.season) {
        this.filter.season_id = element.season_id;
      }
    });
    // console.log("check season_id", this.filter.season_id)
  }
  OnHandle(type) {
    this.IsShow = type

    let res = this.shirtStock.filter((e) => e.is_checked)

    this.so_id = ''

    res.forEach((e, ind) => {
      if (e.is_checked)
        this.so_id += e.so_id + (ind == res.length - 1 ? '' : ',')
    })
    this.getNewPendingOrder();
  }
  onBoxClick(i, event: any) {

    this.shirtStock[i].is_checked = event.target.checked;

  }
  HideModel() {
    this.IscancelShow = false;
    this.cancel_data = [];
  }
  deletecalled() {
    this.IscancelShow = true;
    this.cancel_data = this.shirtStock.filter((e) => e.is_selected == true)

    console.log(this.cancel_data, "checkkkkkkking the canceldata")
  }
  onBoxcancelClick(i, event: any) {

    this.shirtStock[i].is_selected = event.target.checked;

  }
  reasonchange(val ,ind) {
    // this.cancel_data.forEach((e) => {
    //   e.reason = val
    // })
    this.cancel_data[ind].reason = val
  }
  allseason() {
    let fin_id = parseInt(this.filter.fin_id);

    this.seasonList.forEach(() => {
      let seasonAll = {
        season: "ALL",
        season_id: this.seasonList[this.seasonList["length"] - 1].season_id + 1,
        fin_id: fin_id,
      };
      if (fin_id > 0) {
        this.seasonList.push(seasonAll);
      }
      fin_id = fin_id - 1;
    });
  }


  onGoToNextFld1($event, fld, ind) {
    if (fld == 'rf36')
      ind = ind + 1;
    setTimeout(() => {
      $("#" + fld + "-" + ind).focus()
    }, 100);
  }
  GetPartyview() {
    this.party_view = true;
  }
  SelectParty(id) {
    this.filter.party_id = id
    this.getNewPendingOrder();

  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  tabstyle(boolean) {
    this.tab_index = boolean;
  }
  allPartysave() {
    let that = this;
    swal({
      title: "Are you sure to save Party Details?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function (res: any) {
      that.toasterService.pop({
        bodyOutputType: 1,
        type: "success",
        title: "SUCCESS",
      });
    })
    // })
  }
  getNewPendingOrder() {
    this.IsWait = true;

    if (this.filter.newDesignShade == "") {
      this.filter.groupby = "";
    }
    this.filter.from_date = this.datePipe.transform(
      this.filter.from_date,
      "yyyy-MM-dd"
    );
    this.filter.to_date = this.datePipe.transform(
      this.filter.to_date,
      "yyyy-MM-dd"
    );
    let params = {
      filter: JSON.stringify(this.filter),
      page_type: this.IsShow,
      so_id: this.so_id
    };

    let that = this;

    that.gridOptions = {
      loading: true,
      columns: [],
    };
    that.salesOrderServ.getcountCustomer(params).then((res: any) => {
      that.shirtStock = res.Pendordstock.data
      // console.log(res.Pendordstock.data, "dddddddddddata", res.stockpcs.data)
      if (!this.IsShow) {
        res.stockpcs.data.forEach(el => {
          res.Pendordstock.data.forEach(e => {
            if (el.design_id == e.design_id) {
              if((e.f36 > 0) && (el.st_f36 > 0) ||  (e.f38 > 0) && (el.st_f38 > 0) ||  (e.f40 > 0) && (el.st_f40 > 0) ||  (e.f42 > 0) && (el.st_f42 > 0) ||  (e.f44 > 0) && (el.st_f44 > 0) ||  (e.f46 > 0) && (el.st_f46 > 0) || (e.h36 > 0) && (el.st_h36 > 0) ||  (e.h38 > 0) && (el.st_h38  > 0) ||  (e.h40 > 0) && (el.st_h40 > 0) ||  (e.h42 > 0) && (el.st_h42 > 0) ||  (e.h44 > 0) && (el.st_h44  > 0) ||  (e.h46 > 0) && (el.st_h46 > 0)){
              el.so_f36 = e.f36;
              el.so_f38 = e.f38;
              el.so_f40 = e.f40;
              el.so_f42 = e.f42;
              el.so_f44 = e.f44;
              el.so_f46 = e.f46;
              el.so_h36 = e.h36;
              el.so_h38 = e.h38;
              el.so_h40 = e.h40;
              el.so_h42 = e.h42;
              el.so_h44 = e.h44;
              el.so_h46 = e.h46;
              el.so_total = e.tot_pcs;
              el.so_id = e.so_id,
                el.so_date = e.so_dateformatteds,
                el.so_no = e.so_no
              }
            }

          });
        });
        res.stockpcs.data = res.stockpcs.data.filter((e) => e.so_total > 0);
        that.shirtStock = res.stockpcs.data;
        // console.log(that.shirtStock, "second Level so check")
      }
      that.IsWait = false;

      if (that.filter.groupby == "designColorOrder") {
        that.stockOrder = res.stockArr;
        that.totalOrderPend = res.totalOrderPend;
      }
    });
  }
  setColumns(groupby) {
    if (groupby == "design") {
      this.excelColumns = [
        {
          name: "sno",
          prop: "sno",
        },
        {
          name: "Design No",
          prop: "design_no",
        },
        {
          name: "FTOT",
          prop: "ftot",
        },
        {
          name: "HTOT",
          prop: "htot",
        },
        {
          name: "TOT",
          prop: "tot",
        },
      ];
    } else if (groupby == "designColor") {
      this.excelColumns = [
        {
          name: "sno",
          prop: "sno",
        },
        {
          name: "Design No",
          prop: "design_no",
        },
        {
          name: "Shade",
          prop: "shade",
        },
        {
          name: "F36",
          prop: "f36",
        },
        {
          name: "F38",
          prop: "f38",
        },
        {
          name: "F40",
          prop: "f40",
        },
        {
          name: "F42",
          prop: "f42",
        },
        {
          name: "F44",
          prop: "f44",
        },
        {
          name: "F46",
          prop: "f46",
        },
        {
          name: "H36",
          prop: "h36",
        },
        {
          name: "H38",
          prop: "h38",
        },
        {
          name: "H40",
          prop: "h40",
        },
        {
          name: "H42",
          prop: "h42",
        },
        {
          name: "H44",
          prop: "h44",
        },
        {
          name: "H46",
          prop: "h46",
        },
        {
          name: "F.TOT",
          prop: "ftot",
        },
        {
          name: "H.TOT",
          prop: "htot",
        },
        {
          name: "TOT",
          prop: "tot",
        },
      ];
    } else if (groupby == "designColorOrder") {
      this.excelColumns = [
        {
          name: "sno",
          prop: "sno",
        },
        {
          name: "So.No",
          prop: "so_no",
        },
        {
          name: "So.Date",
          prop: "so_date",
        },
        {
          name: "Party Name",
          prop: "party_name",
        },
        {
          name: "F36",
          prop: "f36",
        },
        {
          name: "F38",
          prop: "f38",
        },
        {
          name: "F40",
          prop: "f40",
        },
        {
          name: "F42",
          prop: "f42",
        },
        {
          name: "F44",
          prop: "f44",
        },
        {
          name: "F46",
          prop: "f46",
        },
        {
          name: "H36",
          prop: "h36",
        },
        {
          name: "H38",
          prop: "h38",
        },
        {
          name: "H40",
          prop: "h40",
        },
        {
          name: "H42",
          prop: "h42",
        },
        {
          name: "H44",
          prop: "h44",
        },
        {
          name: "H46",
          prop: "h46",
        },
        {
          name: "F.TOT",
          prop: "ftot",
        },
        {
          name: "H.TOT",
          prop: "htot",
        },
        {
          name: "TOT",
          prop: "tot",
        },
      ];
    }
  }
  calcTotal(ind) {
    let temp: any;
    this.est_stock = 0;

    this.tot_data.est_f36 = 0;
    this.tot_data.est_f38 = 0;
    this.tot_data.est_f40 = 0;
    this.tot_data.est_f42 = 0;
    this.tot_data.est_f44 = 0;
    this.tot_data.est_f46 = 0;
    this.tot_data.est_h36 = 0;
    this.tot_data.est_h38 = 0;
    this.tot_data.est_h40 = 0;
    this.tot_data.est_h42 = 0;
    this.tot_data.est_h44 = 0;
    this.tot_data.est_h46 = 0;
    this.tot_data.est_tot = 0;


    this.tot_data.bal_f36 = 0;
    this.tot_data.bal_f38 = 0;
    this.tot_data.bal_f40 = 0;
    this.tot_data.bal_f42 = 0;
    this.tot_data.bal_f44 = 0;
    this.tot_data.bal_f46 = 0;
    this.tot_data.bal_h36 = 0;
    this.tot_data.bal_h38 = 0;
    this.tot_data.bal_h40 = 0;
    this.tot_data.bal_h42 = 0;
    this.tot_data.bal_h44 = 0;
    this.tot_data.bal_h46 = 0;
    this.tot_data.bal_tot = 0;


    this.shirtStock.forEach(e => {

      e.bf36 = (e.f36 - e.rf36);
      e.bf38 = (e.f38 - e.rf38);
      e.bf40 = (e.f40 - e.rf40);
      e.bf42 = (e.f42 - e.rf42);
      e.bf44 = (e.f44 - e.rf44);
      e.bf46 = (e.f46 - e.rf46);
      e.bh36 = (e.h36 - e.rh36);
      e.bh38 = (e.h38 - e.rh38);
      e.bh40 = (e.h40 - e.rh40);
      e.bh42 = (e.h42 - e.rh42);
      e.bh44 = (e.h44 - e.rh44);
      e.bh46 = (e.h46 - e.rh46);
      e.rtot = ((e.rf36 || 0) + (e.rf38 || 0) + (e.rf40 || 0) + (e.rf42 || 0) + (e.rf44 || 0) + (e.rf46 || 0) + (e.rh36 || 0) + (e.rh38 || 0) + (e.rh40 || 0) + (e.rh42 || 0) + (e.rh44 || 0) + (e.rh46 || 0));

      this.tot_data.est_f36 += e.rf36;
      this.tot_data.est_f38 += e.rf38;
      this.tot_data.est_f40 += e.rf40;
      this.tot_data.est_f42 += e.rf42;
      this.tot_data.est_f44 += e.rf44;
      this.tot_data.est_f46 += e.rf46;
      this.tot_data.est_h36 += e.rh36;
      this.tot_data.est_h38 += e.rh38;
      this.tot_data.est_h40 += e.rh40;
      this.tot_data.est_h42 += e.rh42;
      this.tot_data.est_h44 += e.rh44;
      this.tot_data.est_h46 += e.rh46;

      this.tot_data.bal_f36 += e.bf36;
      this.tot_data.bal_f38 += e.bf38;
      this.tot_data.bal_f40 += e.bf40;
      this.tot_data.bal_f42 += e.bf42;
      this.tot_data.bal_f44 += e.bf44;
      this.tot_data.bal_f46 += e.bf46;
      this.tot_data.bal_h36 += e.bh36;
      this.tot_data.bal_h38 += e.bh38;
      this.tot_data.bal_h40 += e.bh40;
      this.tot_data.bal_h42 += e.bh42;
      this.tot_data.bal_h44 += e.bh44;
      this.tot_data.bal_h46 += e.bh46;


      this.est_stock += e.rtot;

    })


    this.tot_data.bal_tot = this.tot_data.bal_f36 + this.tot_data.bal_f38 + this.tot_data.bal_f40 + this.tot_data.bal_f42 + this.tot_data.bal_f44 + this.tot_data.bal_f46 + this.tot_data.bal_h36 + this.tot_data.bal_h38 + this.tot_data.bal_h40 + this.tot_data.bal_h42 + this.tot_data.bal_h44 + this.tot_data.bal_h46


    this.tot_data.est_tot = this.tot_data.est_f36 + this.tot_data.est_f38 + this.tot_data.est_f40 + this.tot_data.est_f42 + this.tot_data.est_f44 + this.tot_data.est_f46 + this.tot_data.est_h36 + this.tot_data.est_h38 + this.tot_data.est_h40 + this.tot_data.est_h42 + this.tot_data.est_h44 + this.tot_data.est_h46

    this.balance_qty = this.tot_stock - this.est_stock;
  }
  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }
  onSelectClicked(event, i) {
    this.Iselected_party = false;

    if (event.target.checked) {
      this.filter.est_partyid = this.pendingOrderStock[i].party_id;
      this.pendingOrderStock = this.pendingOrderStock.filter(
        e => e.party_id == this.filter.est_partyid

      )
      this.Iselected_party = true;
      this.tot_data.so_f36 = 0;
      this.tot_data.so_f38 = 0;
      this.tot_data.so_f40 = 0;
      this.tot_data.so_f42 = 0;
      this.tot_data.so_f44 = 0;
      this.tot_data.so_f46 = 0;
      this.tot_data.so_h36 = 0;
      this.tot_data.so_h38 = 0;
      this.tot_data.so_h40 = 0;
      this.tot_data.so_h42 = 0;
      this.tot_data.so_h44 = 0;
      this.tot_data.so_h46 = 0;
      this.tot_data.so_tot = 0;

      this.pendingOrderStock.forEach(e => {
        this.tot_data.so_f36 += e.f36;
        this.tot_data.so_f38 += e.f38;
        this.tot_data.so_f40 += e.f40;
        this.tot_data.so_f42 += e.f42;
        this.tot_data.so_f44 += e.f44;
        this.tot_data.so_f46 += e.f46;
        this.tot_data.so_h36 += e.h36;
        this.tot_data.so_h38 += e.h38;
        this.tot_data.so_h40 += e.h40;
        this.tot_data.so_h42 += e.h42;
        this.tot_data.so_h44 += e.h44;
        this.tot_data.so_h46 += e.h46;
      });

      this.tot_data.so_tot = this.tot_data.so_f36 + this.tot_data.so_f38 + this.tot_data.so_f40 + this.tot_data.so_f42 + this.tot_data.so_f44 + this.tot_data.so_f46 + this.tot_data.so_h36 + this.tot_data.so_h38 + this.tot_data.so_h40 + this.tot_data.so_h42 + this.tot_data.so_h44 + this.tot_data.so_h46

    }

  }
  deleteRow() {
    let params: any = Object.assign({}, this.filter);
    params["tabevent"] = undefined;
    params["soGrid"] = JSON.stringify(this.cancel_data);
    let that = this;
    if (this.cancel_data.length) {
      swal({
        title: "Are you sure to Cancel this details?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, cancel it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
          that.salesOrderServ.
            updateSalesOrderCancel(params)
            .then(function (res: any) {
              that.IscancelShow = false;
              that.getNewPendingOrder()
              // let tabObj = {
              //   action: "CloseTab",
              //   params: {},
              // };
              // that.tabUpdateEvent.emit(tabObj);
            })
      });
    } else {
      swal({
        type: 'warning',
        title: "Select Atleast One Ord.Pcs",
        showConfirmButton: true
      });
    }
  }
  ngOnDestroy() {
    this.salesOrderServ;
  }
  twoSideScroll() {
    $("twosidescroll").on("scroll", function () {
      $("twosidescroll:not(this)").scrollTop($(this).scrollTop());
    });
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/SalesOrderReports/designSoReport/countCustomer.ts